import type { IProbeCreatedNotificationData } from "@frontend-shared/types";
import { ShieldCheck } from "lucide-react";
import { memo, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IProbeCreatedCardProps {
  uuid: string;
  data: IProbeCreatedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewProbes: (projectUuid: string) => void;
}

const ProbeCreatedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewProbes,
}: IProbeCreatedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewProbes = useCallback(
    () => onViewProbes(data.projectUuid),
    [onViewProbes, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="probe_created"
      createdAt={createdAt}
      isRead={isRead}
      icon={<ShieldCheck className="h-5 w-5 text-rose-500" />}
      iconBgClassName="bg-rose-500/10"
      ctaLabel={t("view_probes")}
      onCtaClick={handleViewProbes}
      body={
        <Trans
          ns="notifications"
          i18nKey="type.probe_created.body"
          values={{
            creatorName: data.creatorName,
            probeName: data.probeName,
            projectTitle: data.projectTitle,
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const ProbeCreatedCard = memo(ProbeCreatedCardComponent);
